/* Optional, opt-in daily check-in reminder. Off by default. No streaks.
 * Uses the Notification Triggers API (Chromium / installed PWA) to fire even
 * when the app is closed; falls back to a gentle in-app nudge on next open. */
const KEY = "ss_reminder";
const DEFAULT = { enabled: false, time: "09:00", granted: false };

export function getReminder() {
  try {
    return { ...DEFAULT, ...(JSON.parse(localStorage.getItem(KEY)) || {}) };
  } catch {
    return { ...DEFAULT };
  }
}

function save(r) {
  localStorage.setItem(KEY, JSON.stringify(r));
}

function nextOccurrence(time) {
  const [h, m] = time.split(":").map(Number);
  const now = new Date();
  const t = new Date();
  t.setHours(h, m, 0, 0);
  if (t.getTime() <= now.getTime()) t.setDate(t.getDate() + 1);
  return t.getTime();
}

async function scheduleTrigger(time) {
  if (!("serviceWorker" in navigator) || !("TimestampTrigger" in window)) return false;
  try {
    const reg = await navigator.serviceWorker.ready;
    const existing = await reg.getNotifications({ tag: "ss-daily", includeTriggered: true });
    existing.forEach((n) => n.close());
    await reg.showNotification("Signal State ID", {
      tag: "ss-daily",
      body: "A gentle moment to check in with yourself.",
      icon: "/icon-192.png",
      badge: "/icon-192.png",
      data: { url: "/navigate", time },
      // eslint-disable-next-line no-undef
      showTrigger: new TimestampTrigger(nextOccurrence(time)),
    });
    return true;
  } catch {
    return false;
  }
}

async function cancelTrigger() {
  if (!("serviceWorker" in navigator)) return;
  try {
    const reg = await navigator.serviceWorker.ready;
    const existing = await reg.getNotifications({ tag: "ss-daily", includeTriggered: true });
    existing.forEach((n) => n.close());
  } catch {
    /* no-op */
  }
}

export async function enableReminder(time) {
  let granted = false;
  if ("Notification" in window) {
    try { granted = (await Notification.requestPermission()) === "granted"; } catch { /* no-op */ }
  }
  save({ enabled: true, time, granted });
  if (granted) await scheduleTrigger(time);
  return getReminder();
}

export async function disableReminder() {
  const r = getReminder();
  save({ ...r, enabled: false });
  await cancelTrigger();
  return getReminder();
}

export function markCheckin() {
  localStorage.setItem("ss_last_checkin", new Date().toISOString().slice(0, 10));
}

// In-app fallback: if today's reminder is due and no check-in yet, nudge once.
export function tickReminder(onRemind) {
  const r = getReminder();
  if (!r.enabled) return;
  const today = new Date().toISOString().slice(0, 10);
  if (localStorage.getItem("ss_last_checkin") === today) return;
  if (localStorage.getItem("ss_reminded_on") === today) return;
  const [h, m] = r.time.split(":").map(Number);
  const now = new Date();
  if (now.getHours() * 60 + now.getMinutes() < h * 60 + m) return;
  localStorage.setItem("ss_reminded_on", today);
  if (typeof onRemind === "function") onRemind();
  scheduleTrigger(r.time); // re-arm for tomorrow
}
